// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"8742e501","488":"fc32fdd6","521":"a86f7c4e","523":"ec2178de","620":"895ea007","629":"62cb14d5","809":"f272065e","820":"3798ad6e","915":"fc1074cb"}[chunkId] + ".chunk.js";
};